import type { ReactNode } from 'react'

/**
 * The social networks' marks, drawn inline in `currentColor`, as the mockups'
 * `components/layout/SocialIcons.jsx` draws them: Material Symbols has no brand marks.
 */
function BrandIcon(props: { readonly outlined?: boolean; readonly children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      aria-hidden="true"
      {...(props.outlined === true
        ? { fill: 'none', stroke: 'currentColor', strokeWidth: 2 }
        : { fill: 'currentColor' })}
    >
      {props.children}
    </svg>
  )
}

const slackUnit = (
  <>
    <rect x="8.9" y="2" width="2.8" height="9" rx="1.4" />
    <rect x="2.5" y="9.2" width="5.4" height="2.8" rx="1.4" />
  </>
)

export const SlackIcon = () => (
  <BrandIcon>
    {slackUnit}
    <g transform="rotate(90 12 12)">{slackUnit}</g>
    <g transform="rotate(180 12 12)">{slackUnit}</g>
    <g transform="rotate(270 12 12)">{slackUnit}</g>
  </BrandIcon>
)

export const LinkedInIcon = () => (
  <BrandIcon>
    <path
      fillRule="evenodd"
      d="M5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm.2 8H8.2v9H5.2v-9Zm1.5-4.6a1.7 1.7 0 1 1 0 3.4 1.7 1.7 0 0 1 0-3.4ZM10.2 10H13v1.3c.5-.9 1.6-1.5 2.9-1.5 2.6 0 3.3 1.6 3.3 4V19h-3v-4.6c0-1.1-.2-1.9-1.4-1.9-1.2 0-1.6.9-1.6 1.9V19h-3v-9Z"
    />
  </BrandIcon>
)

export const FacebookIcon = () => (
  <BrandIcon>
    <path
      fillRule="evenodd"
      d="M5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-4.6v-7.4h2.5l.4-2.9h-2.9V9.9c0-.8.3-1.4 1.5-1.4H17V6c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2H8.5v2.9h2.6V22H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z"
    />
  </BrandIcon>
)

export const XIcon = () => (
  <BrandIcon>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </BrandIcon>
)

export const YouTubeIcon = () => (
  <BrandIcon>
    <path
      fillRule="evenodd"
      d="M6 5h12a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4Zm4 4v6l5.2-3L10 9Z"
    />
  </BrandIcon>
)

export const InstagramIcon = () => (
  <BrandIcon outlined>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" />
  </BrandIcon>
)
